export default __webpack_public_path__ + "static/1377-9306ed89f45b0f87b0f4b43f469a72c0.gif";